export { default as InputNumber } from './InputNumber';
